import { FC, RefObject } from 'react';

import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import { FormHandles } from '@unform/core';
import DatePickerOperator from 'src/components/Form/DatePickerOperator';
import Select from 'src/components/Form/Select';
import { Item } from 'src/components/Form/Select/interfaces';
import TextField from 'src/components/Form/TextField';

interface FilterProps {
  formRef?: RefObject<FormHandles>;
}

const statusItems: Item[] = [
  { key: 1, label: 'Ativo', value: 'active' },
  { key: 2, label: 'Inativo', value: 'inactive' },
];

const Filters: FC<FilterProps> = () => {
  return (
    <>
      <Grid item xs={12}>
        <Divider />
      </Grid>

      <Grid item xs={12}>
        <TextField name="name" label="Nome" size="small" />
      </Grid>

      <Grid item xs={12}>
        <DatePickerOperator
          name="start_at"
          label="Ínicio"
          datePickerProps={{ size: 'small' }}
          selectOperatorProps={{ size: 'small' }}
        />
      </Grid>

      <Grid item xs={12}>
        <DatePickerOperator
          name="end_at"
          label="Fim"
          datePickerProps={{ size: 'small' }}
          selectOperatorProps={{ size: 'small' }}
        />
      </Grid>

      <Grid item xs={12}>
        <Select name="status" label="Status" items={statusItems} size="small" />
      </Grid>
    </>
  );
};

export default Filters;
